import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ jsx("svg", { "aria-hidden": "true", viewBox: "0 0 24 24", fill: "currentColor", role: "img", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" }) });
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
